import { createPortal } from "react-dom";

interface LoadingProps {
  isLoading?: boolean;
}

export function Loading({ isLoading = true }: LoadingProps) {
  if (!isLoading) return null;

  return createPortal(
    <div className="fixed inset-0 w-full h-full z-[9999] overflow-hidden bg-gray-700/75 flex flex-col items-center justify-center">
      <div className="relative w-1/6 bg-gray-200 rounded">
        <div className="w-full absolute top-0 h-4 rounded shim-green" />
      </div>
      <div className="flex gap-2">
        <h2 className="pt-2 text-center text-white text-xl font-semibold">
          Carregando
        </h2>
        <div className="flex items-end mb-1 gap-1">
          <div
            className="bg-white w-2 h-2 rounded-full animate-bounce"
            style={{ animationDelay: "0ms" }}
          />
          <div
            className="bg-white w-2 h-2 rounded-full animate-bounce"
            style={{ animationDelay: "150ms" }}
          />
          <div
            className="bg-white w-2 h-2 rounded-full animate-bounce"
            style={{ animationDelay: "300ms" }}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
}
